export default {
  galleryIconWrapper: 'fixed top-0 right-0 p-[20px] z-20',
  closeModalIcon: 'bg-[#E7E8EA] flex items-center justify-center h-[24px] w-[24px] rounded-full cursor-pointer',
  sliderContainer: 'fixed top-0 left-0 bottom-0 bg-[#10182880] w-[100%] overflow-y-auto',
  hidden: 'hidden',
};
